var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatyaNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 468,
    viewBox: "0 0 97 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0099 374.926L58.0099 363.759L22.8238 368.798L22.8238 369.888L58.0099 374.926ZM97 358.174L76.2148 361.171L76.2148 377.514L97 380.51L97 402.437L-7.44175e-07 385.413L-2.15506e-06 353.136L97 336.111L97 358.174Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.63128e-06 276.729L22.8238 276.729L22.8238 296.068L97 296.068L97 317.45L22.8238 317.45L22.8239 336.926L0 336.926L-2.63128e-06 276.729Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.04193e-06 225.114L-3.08965e-06 201.145L51.8281 225.795L97 225.795L97 247.178L51.8281 247.178L0 271.828L-1.04778e-06 247.858L30.3634 236.69L30.3634 236.146L-2.04193e-06 225.114Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0099 178.673L58.0099 167.504L22.8238 172.544L22.8238 173.634L58.0099 178.673ZM97 161.921L76.2148 164.917L76.2148 181.259L97 184.256L97 206.184L-7.44174e-07 189.159L-2.15505e-06 156.882L97 139.857L97 161.921Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97 131.003L70.6442 131.003L34.2358 94.6396L22.0089 94.6396L22.8238 94.6343L22.8238 110.532L22.0089 110.575L30.976 110.575L30.976 131.957L13.1772 131.957L-5.71496e-07 118.883L-1.98837e-06 86.4685L13.1772 70.158L39.805 70.158L74.7203 105.159L72.1309 105.159L72.1309 69.4767L97 69.4767L97 131.003Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5014 22.3231L39.6696 22.3231L39.6696 40.0291L22.0089 40.0291L21.9773 39.9975L21.9773 22.5761L22.0773 22.3231L39.5014 22.3231ZM-2.06572e-06 14.152L-5.77427e-07 48.2002L13.1785 61.4102L47.6864 61.4102L60.8636 48.2002L60.8636 22.3231L74.9924 22.3231L74.9924 38.938L66.0266 38.938L66.0266 60.3217L83.8228 60.3217L97 47.1118L97 14.152L83.8228 0.940701L13.1785 0.940704L-2.06572e-06 14.152Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4879 446.559L60.3667 446.559L75.4879 430.761L75.4879 446.559ZM21.1532 446.559L21.1532 431.714L36.2731 446.559L21.1532 446.559ZM46.8714 425.255L33.1868 410.468L13.1785 410.468L-1.94075e-06 423.542L0 467.941L97 467.941L97 422.454L83.8228 409.378L61.5668 409.378L46.8714 425.255Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatyaNext);
export default __webpack_public_path__ + "static/media/batya_next.20eaef13e9090ca70038fbde2411ae0c.svg";
export { ForwardRef as ReactComponent };